import { render, staticRenderFns } from "./mElectronicFooter.vue?vue&type=template&id=3e7fc930&scoped=true"
import script from "./mElectronicFooter.vue?vue&type=script&lang=js"
export * from "./mElectronicFooter.vue?vue&type=script&lang=js"
import style0 from "./mElectronicFooter.vue?vue&type=style&index=0&id=3e7fc930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7fc930",
  null
  
)

export default component.exports